import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

const state = {
  me: {},
  vacations: {},
  holidays: {},
  newVacations: [],
  newHolidays: [],
  startDate: '',
  endDate: '',
  selectDay: [],
  selectedYear: new Date().getFullYear(),
  bookedDays: 0,
  showMore: '',
  editingId: '',
  updateVacations: false,
  updateHolidays: false,
  apiError: undefined,
  availableDays: 27,
  kaleiders: [],
  importVacationsSuccess: false,
  holidayName: ''
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js